import * as Sentry from '@sentry/nuxt'

const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost'

Sentry.init({
  // If set up, you can use your runtime config here
  // dsn: useRuntimeConfig().public.sentry.dsn,
  dsn: 'https://c041d9c90f222c2b985d1dd3cb9f5551@o4510777432801280.ingest.us.sentry.io/4510805099741184',

  // Disable on localhost
  enabled: !isLocalhost,

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Enable sending of user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nuxt/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})
